<template>
  <span
    :class="[
      'text-xs font-semibold text-center uppercase inline-flex items-center',
      {
        'rounded-md p-2 justify-center': display == 'full',
      },
      {
        'bg-info/20 text-info': (status == PROJECT_STATUS.LEAD && display != 'text'),
        'bg-secondary text-primary': (status == PROJECT_STATUS.ESTIMATING  && display != 'text'),
        'bg-accent/20 text-accent':( status == PROJECT_STATUS.AWAITING_ACCEPTANCE && display != 'text'),
        'bg-error/20 text-error': (status == PROJECT_STATUS.LOST && display != 'text'),
        'bg-success/20 text-green-600':( status == PROJECT_STATUS.IN_PROGRESS && display != 'text'),
        'bg-warning/20 text-warning': (status == PROJECT_STATUS.INVOICING && display != 'text'),
        'bg-success/50 text-green-900': (status == PROJECT_STATUS.COMPLETED && display != 'text'),
        'bg-slate-100 text-slate-800': (status == PROJECT_STATUS.ARCHIVED && display != 'text')
      }
    ]"
  >
    <span v-if="display == 'stripe'" class="h-full min-h-10 min-w-1">&nbsp;</span>
    <span v-if="display == 'dot'" class="rounded-full size-2">&nbsp;</span>
    <span
      v-else-if="display == 'full' || display == 'text'"
      :class="[
        'sm:truncate',
        {
          'text-info': status == PROJECT_STATUS.LEAD,
          'text-primary': status == PROJECT_STATUS.ESTIMATING ,
          'text-accent': status == PROJECT_STATUS.AWAITING_ACCEPTANCE,
          'text-error': status == PROJECT_STATUS.LOST,
          'text-green-600': status == PROJECT_STATUS.IN_PROGRESS,
          'text-warning': status == PROJECT_STATUS.INVOICING,
          'text-green-900': status == PROJECT_STATUS.COMPLETED,
          'text-slate-800': status == PROJECT_STATUS.ARCHIVED
        }
      ]"
    >
      {{
        status == PROJECT_STATUS.LEAD ? 'Lead' :
        status == PROJECT_STATUS.ESTIMATING ? 'Estimating' :
        status == PROJECT_STATUS.AWAITING_ACCEPTANCE ? 'Awaiting' :
        status == PROJECT_STATUS.LOST ? 'Declined' :
        status == PROJECT_STATUS.IN_PROGRESS ? 'In Progress' :
        status == PROJECT_STATUS.INVOICING ? 'Invoicing' :
        status == PROJECT_STATUS.COMPLETED ? 'Completed' :
        status == PROJECT_STATUS.ARCHIVED ? 'Archived' : ''
      }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { PROJECT_STATUS } from '@/models/project'

defineProps({
  status: {
    type: String,
    required: true
  },
  display: {
    type: String as PropType<'text' | 'dot' | 'stripe' | 'full'>,
    default: 'full'
  },
  colorOnly: {
    type: Boolean,
    default: false
  },
  statusDot: {
    type: Boolean,
    default: false
  }
})
</script>
